import React from "react";
import close from "../../../../../assets/images/close-icon.svg";

import styles from "./OldMemberModal.scss";

const OldMemberModal = props => (
  <div className={styles.oldMemberModal}>
    <div className={styles.modalContainer}>
      <img
        src={close}
        className={styles.closebutton}
        onClick={() => props.onHide()}
      />
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h2 className={styles.title}>Welcome to Our New Platform!</h2>
          <div className={styles.intro}>
            <p>
              We have been working hard to make improvements to your experience
              using The Second Shift. These include more detailed profiles for
              you, so companies can get a better view on who you are and all of
              your great work experience.
            </p>
          </div>
        </div>
        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>
        <div>
          <h3 className={styles.subTitle}>This is where you come in.</h3>
        </div>
        <div className={styles.intro}>
          <p>
            Before you continue with viewing and pitching projects, please be
            sure to:
          </p>
          <ul>
            <li>
              Add a link to your <strong>LinkedIn profile</strong>, upload your
              most recent <strong>resume</strong>, and add your{" "}
              <strong>website url</strong> (if you have one).
            </li>
            <li>
              Check that all of your <strong>skills</strong> are up to date. We
              have made many changes to our skills list, so this is important to
              ensure you're being properly matched to projects.
            </li>
            <li>
              Insert your <strong>work history</strong>.
            </li>
            <li>Select your nearest major metro area.</li>
          </ul>
          <p>
            All of these updates will help to present you to companies in a
            better way, and, we hope, improve your matching and pitching
            process.
          </p>
          <p>
            If you have any feedback about your experience with our new
            platform, please don't hesitate to contact us.
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <span className={styles.acceptButton} onClick={props.onHide}>
            Update Your Profile
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default OldMemberModal;



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/components/oldMemberModal/OldMemberModal.js